module.exports = __webpack_public_path__ + "static/media/parkhub-vip-logo-gray.4e8b3ce5.svg";